import React from 'react'
import styled from '@emotion/styled'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import { Typography } from 'src/components/atoms/Typography'

type Props = {
  heading: string
}

const HeadingBorder = ({ heading }: Props) => {
  return <Heading>{heading}</Heading>
}

const Heading = styled(Typography)`
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  letter-spacing: 1.4px;
  text-align: left;
  color: #22475d;
  position: relative;
  margin-bottom: ${Styles.spacing[7]};
  &:before {
    content: '';
    width: 10px;
    height: 1px;
    background-color: #22475d;
    position: absolute;
    top: 50%;
    left: -20px;
  }
  @media screen and (max-width: ${BreakPoint.TABLET_MIN_WIDTH}) {
    margin-left: 20px;
  }
`

export default HeadingBorder
